import { createContext, useContext } from 'react'

import type { ColorScheme } from '../../types'

export const TableColorSchemeContext = createContext<ColorScheme>('dark')

export const useTableColorScheme = (): ColorScheme =>
  useContext(TableColorSchemeContext)

export type TableDensity = 'default' | 'compact' | 'comfortable'

export const TableDensityContext = createContext<TableDensity>('default')

export const useTableDensity = (): TableDensity =>
  useContext(TableDensityContext)

/**
 * `embedded`: the table sits flush inside an already-bordered container (e.g.
 * a SummaryPanel drill-down), so it drops its outer border and sets its
 * header on the elevated card background.
 */
export type TableVariant = 'default' | 'embedded'

export const TableVariantContext = createContext<TableVariant>('default')

export const useTableVariant = (): TableVariant =>
  useContext(TableVariantContext)

// ─── Sort context ─────────────────────────────────────────────────────────────

export type TableSortContextValue = {
  sortableColumns: string[]
  activeColumn: string | null
  activeOrder: 'asc' | 'desc' | null
  onColumnSort: (column: string) => void
}

const defaultSortContext: TableSortContextValue = {
  sortableColumns: [],
  activeColumn: null,
  activeOrder: null,
  onColumnSort: () => {},
}

export const TableSortContext =
  createContext<TableSortContextValue>(defaultSortContext)

export const useTableSortContext = (): TableSortContextValue =>
  useContext(TableSortContext)
